const apiUrl = process.env.REACT_APP_API_URL

export default async function getSkills() {
    const token = localStorage.getItem('token')
    const res = await fetch(`${apiUrl}/skills`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
    const response: Response = await res.json()

    return { skills: response?.skills ?? [] }
}

export interface Skill {
    id: string
    name: string
    description: string
}

interface Response {
    skills: Skill[]
}
